import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

export const VisibilityMenu = styled.div`
    display: flex;
    flex-direction: column;

    padding: 3px 0;

    background: ${Colors.WHITE};
    border-radius: 6px;
    box-shadow: 0 12px 20px rgba(0, 0, 0, 8%);
`;
